export default {
    state: {
        // 商家信息
        id: null,
        name: null,
        projectTitle: null,
        customerTitle: null,
        employeeTitle: null,
        amountType: null,
        unitTitle: null,
        endTime: null,
        employeeName: null,
        shopType: null,
        shopTypeName: null,
    },

    getters: {
    },

    // setter
    mutations: {
        setShopInfo(state, value){
            if(!value){
                return;
            }
            state.id = value.id;
            state.name = value.name;
            state.projectTitle = value.projectTitle;
            state.customerTitle = value.customerTitle;
            state.employeeTitle = value.employeeTitle;
            state.amountType = value.amountType;
            state.unitTitle = value.unitTitle;
            state.endTime = value.endTime;
            state.employeeName = value.employeeName;
            state.shopType = value.shopType;
            state.shopTypeName = value.shopTypeName;
        }
    },

    actions: {
    },

    modules: {
    }
}